/**
* Details JS
* -----------------------------------------------------------------------------
*
* All the JS for the Details component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );

( function( app ) {
  const COMPONENT = {

    className: 'details',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.details' ).each( function() {
        const image = $( this ).find( '.details__bg' )[0];
        const overlay = $( this ).find( '.details__bg .overlay' )[0];

        // const imageHeight = $( this ).find( '.details__bg' ).outerHeight();
        // const contentHeight = $( this ).find( '.details__content' ).outerHeight();
        // contentHeight + ( imageHeight / 2.5 )

        gsap.to( overlay, {
          scrollTrigger: {
            trigger: this,
            start: 'top 0%',
            scrub: 0.15,
            pin: image,
            // markers: true,
          },
          opacity: '0.75',
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'details', COMPONENT );
} )( app );
